import { graphql } from '@/gql';
import type { GenerateSmsExampleQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const generateSmsExample = async ({
  smsRecipientName,
  smsTopicName,
  smsName,
}: GenerateSmsExampleQueryVariables): Promise<string> => {
  const response = await queryExecute({
    query: graphql(`
      query GenerateSmsExample($smsRecipientName: SmsRecipientName!, $smsTopicName: SmsTopicName!, $smsName: String!) {
        generateSmsExample(smsRecipientName: $smsRecipientName, smsTopicName: $smsTopicName, smsName: $smsName)
      }
    `),
    variables: {
      smsRecipientName,
      smsTopicName,
      smsName,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.generateSmsExample;
};
